module.exports = __webpack_public_path__ + "static/img/login-bg.f3332e05.png";